<template>
  <div v-if="!booking.is_offer">
    <ul class="item-detail item-detail-simple">
      <li>
        <a href="#modal-change-log" data-toggle="modal" data-target="#modal-change-log">
          <div class="row">
            <div class="col-xs-8">
              <h3>Change Log</h3>
            </div>
            <div class="col-xs-4">
              <div class="actions pull-right">
                <span class="btn btn-info">
                  <i class="fa fa-eye"></i>
                </span>
              </div>
            </div>
          </div>
        </a>
      </li>
    </ul>

    <booking-history-modal :booking="booking"/>
  </div>
</template>

<script>
import BookingHistoryModal from './BookingHistoryModal'

export default {
  props: {
    booking: {
      required: true,
      type: Object
    }
  },

  components: {
    BookingHistoryModal
  }
}
</script>
